var _rect, _path, _rect2, _path2, _rect3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiFid = function SvgMultiFid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.815,
    height: 13.908,
    fill: "#D7B97C",
    rx: 1,
    transform: "matrix(.8722 -.48915 .51093 .85962 2 11.203)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.401 12.786c2.046 2.228 2.085 3.525 2.14 4.107.132-1.047.009-3.166-1.385-4.683-1.825-1.989-2.157-3.093-2.18-3.944-.265 2.41.713 3.745 1.425 4.52",
    clipRule: "evenodd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18.913,
    height: 13.833,
    fill: "currentColor",
    rx: 1,
    transform: "matrix(.96776 -.25189 .26591 .964 6.828 13.553)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.419 17.949c1.382 2.666 1.074 3.928.972 4.504.407-.978.852-3.055-.09-4.872-1.233-2.38-1.259-3.53-1.055-4.358-.897 2.261-.309 3.797.173 4.726",
    clipRule: "evenodd"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 18.449,
    height: 13.305,
    x: 11.25,
    y: 16.25,
    fill: "#fff",
    stroke: "#D7D7D7",
    strokeWidth: 0.5,
    rx: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.11 23.103c.624 2.923-.01 4.065-.261 4.596.654-.843 1.637-2.737 1.211-4.728-.557-2.609-.275-3.726.142-4.475-1.47 1.958-1.31 3.59-1.092 4.607",
    clipRule: "evenodd"
  })));
};
export default SvgMultiFid;